import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import { useSaveScreen } from './_requests/saveScreen'
import { useScreen } from './_load/ScreenLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditScreenForm = () => {
  const { initialState } = useModalData() || {}
  const screen = useScreen()
  const [onSubmit, { loading, error }] = useSaveScreen()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={screen || initialState || {}}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditScreenForm
